export default __webpack_public_path__ + "fa136f982ad43bb9918e40b3ed4ae0fe.png";